(function ($) {
  'use strict';

  window.CTA = new this.CyclingTrips();

  var $body = $('body');
  if ($body.hasClass('post-type-archive-cycling_trips')) {
    // Load the archive functionality
    new this.CyclingTrips.Archive();
  } else if ($body.hasClass('single-cycling_trips')) {
    // Load the detail specific functionality
    new this.CyclingTrips.Detail();
  }
}).bind(window)(jQuery);
